import { defineComponent, ref } from '@vue/composition-api';
import __vue_component__$1 from '../SdsButtonIcon/SdsButtonIcon.vue.js';
import __vue_component__ from '../SdsBaseInput/SdsBaseInput.vue.js';
import __vue_component__$2 from './SdsPasswordStrength.vue.js';

var script = defineComponent({
    name: 'SdsInputPassword',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: undefined,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isReadOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
        status: {
            type: String,
            required: false,
            default: undefined,
        },
        passwordStrength: {
            type: [String, Number],
            required: false,
            default: undefined,
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'update:value',
        'focus',
        'blur',
        'click',
        'keydown',
        'keypress',
        'keyup',
        // Exposed if we need analytics or some reaction to this
        'cleared',
    ],
    setup: function () {
        var inputType = ref('password');
        function toggleInputType() {
            inputType.value = inputType.value === 'password' ? 'text' : 'password';
        }
        return {
            inputType: inputType,
            toggleInputType: toggleInputType,
        };
    },
    components: {
        SdsBaseInput: __vue_component__,
        SdsButtonIcon: __vue_component__$1,
        SdsPasswordStrength: __vue_component__$2,
    },
});

export default script;
